import React from 'react';
import { Path, SVG } from 'web-common/src/shared/design-system/Utilities';

interface LockProps extends React.SVGProps<SVGSVGElement> {
  unlocked?: boolean;
}

export const Lock: React.FC<LockProps> = ({ unlocked = false, ...props }) => {
  if (unlocked) {
    return <UnlockedLock {...props} />;
  }

  return (
    <SVG width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6 8C4.89543 8 4 8.89543 4 10V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V10C20 8.89543 19.1046 8 18 8H6ZM12 17C13.1046 17 14 16.1046 14 15C14 13.8954 13.1046 13 12 13C10.8954 13 10 13.8954 10 15C10 16.1046 10.8954 17 12 17Z'
      />
      <Path
        d='M16 8V7C16 4.79086 14.2091 3 12 3V3C9.79086 3 8 4.79086 8 7V8'
        stroke='currentColor'
        fill='none'
        strokeWidth='2'
      />
    </SVG>
  );
};

export const UnlockedLock = (props: React.SVGProps<SVGSVGElement>) => (
  <SVG width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
    <Path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 9C4.89543 9 4 9.89543 4 11V21C4 22.1046 4.89543 23 6 23H18C19.1046 23 20 22.1046 20 21V11C20 9.89543 19.1046 9 18 9H6ZM12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18Z'
    />
    <Path
      d='M16 9V6C16 3.79086 14.2091 2 12 2V2C9.79086 2 8 3.79086 8 6V6'
      stroke='currentColor'
      fill='none'
      strokeWidth='2'
    />
  </SVG>
);
